import { ITALIC_KEY } from '@techchange/pm-specs';
import { toggleMark } from 'prosemirror-commands';

/**
 * Toggles the italic mark.
 *
 * @param {Object} state     The current editor state.
 * @param {Object} dispatch  The editor dispatch.
 *
 * @returns {boolean} Whether or not the command was successful.
 */
export const toggleItalic = (state, dispatch) => {

	const italicMarkType = state.schema.marks[ITALIC_KEY];

	return toggleMark(italicMarkType)(state, dispatch);

};
